import { gql } from '@apollo/client'

export const GET_PRICE_QUERY = gql`
  query getPrice(
    $sku: String!
    $currency: Currency!
    $country: Country!
    $locale: Locale!
    $channelId: String
  ) {
    product(sku: $sku) {
      masterData {
        published
        current {
          name(locale: $locale)
          categories {
            name(locale: $locale)
          }
          masterVariant {
            sku
            attributesRaw {
              name
              value
            }
            price(currency: $currency, country: $country, channelId: $channelId) {
              custom {
                customFieldsRaw {
                  name
                  value
                }
              }
            }
          }
          variant(sku: $sku) {
            key
            attributesRaw {
              name
              value
            }
            price(currency: $currency, country: $country, channelId: $channelId) {
              value {
                centAmount
                currencyCode
                fractionDigits
                type
              }
              discounted {
                value {
                  centAmount
                  currencyCode
                  fractionDigits
                  type
                }
              }
            }
          }
        }
      }
    }
  }
`
